import { css as h, LitElement as p, html as e, nothing as v } from "lit";
import { property as l, state as f, customElement as u } from "lit/decorators.js";
import { classMap as g } from "lit/directives/class-map.js";
import { b as k } from "./styles-scZ6dVz-.js";
import { b as y, a as m } from "./events-CkEPl0SM.js";
var b = Object.defineProperty, x = Object.getOwnPropertyDescriptor, t = (i, n, c, s) => {
  for (var o = s > 1 ? void 0 : s ? x(n, c) : n, a = i.length - 1, d; a >= 0; a--)
    (d = i[a]) && (o = (s ? d(n, c, o) : d(o)) || o);
  return s && o && b(n, c, o), o;
};
let r = class extends p {
  constructor() {
    super(...arguments), this.severity = "info", this.alertTitle = "", this.description = "", this.closable = !1, this.variant = "default", this.visible = !0, this.closeIcon = e`
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"/>
      <line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  `;
  }
  handleClose() {
    this.visible = !1, this.setAttribute("hidden", ""), y(this, m.CLOSE);
  }
  getIcon() {
    return {
      info: e`
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <line x1="12" y1="16" x2="12" y2="12"/>
          <line x1="12" y1="8" x2="12.01" y2="8"/>
        </svg>
      `,
      success: e`
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
          <polyline points="22 4 12 14.01 9 11.01"/>
        </svg>
      `,
      warning: e`
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
          <line x1="12" y1="9" x2="12" y2="13"/>
          <line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
      `,
      error: e`
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <line x1="15" y1="9" x2="9" y2="15"/>
          <line x1="9" y1="9" x2="15" y2="15"/>
        </svg>
      `
    }[this.severity];
  }
  render() {
    if (!this.visible) return v;
    const i = {
      alert: !0,
      [this.severity]: !0,
      [this.variant]: !0
    };
    return e`
      <div part="alert" class=${g(i)} role="alert">
        <span part="icon" class="icon">
          <slot name="icon">${this.getIcon()}</slot>
        </span>

        <div part="content" class="content">
          ${this.alertTitle ? e`<h4 part="title" class="title">${this.alertTitle}</h4>` : v}
          <div part="description" class="description">
            <slot>${this.description}</slot>
          </div>
          <div part="action" class="action">
            <slot name="action"></slot>
          </div>
        </div>

        ${this.closable ? e`
              <button
                part="close"
                class="close"
                type="button"
                aria-label="Close alert"
                @click=${this.handleClose}
              >
                ${this.closeIcon}
              </button>
            ` : v}
      </div>
    `;
  }
};
r.styles = [
  k,
  h`
      :host {
        display: block;
      }

      :host([hidden]) {
        display: none;
      }

      .alert {
        display: flex;
        align-items: flex-start;
        gap: var(--r5-space-3);
        padding: var(--r5-space-4);
        border-radius: var(--r5-radius-lg);
        border: 1px solid transparent;
      }

      /* Severity: Info */
      .info {
        background-color: oklch(var(--r5-info-l, 0.55) var(--r5-info-c, 0.18) var(--r5-info-h, 250) / 0.1);
        border-color: oklch(var(--r5-info-l, 0.55) var(--r5-info-c, 0.18) var(--r5-info-h, 250) / 0.3);
        color: var(--r5-text);
      }

      .info .icon {
        color: var(--r5-info, oklch(0.55 0.18 250));
      }

      /* Severity: Success */
      .success {
        background-color: oklch(var(--r5-success-l, 0.55) var(--r5-success-c, 0.18) var(--r5-success-h, 145) / 0.1);
        border-color: oklch(var(--r5-success-l, 0.55) var(--r5-success-c, 0.18) var(--r5-success-h, 145) / 0.3);
        color: var(--r5-text);
      }

      .success .icon {
        color: var(--r5-success, oklch(0.55 0.18 145));
      }

      /* Severity: Warning */
      .warning {
        background-color: oklch(var(--r5-warning-l, 0.75) var(--r5-warning-c, 0.18) var(--r5-warning-h, 85) / 0.15);
        border-color: oklch(var(--r5-warning-l, 0.75) var(--r5-warning-c, 0.18) var(--r5-warning-h, 85) / 0.4);
        color: var(--r5-text);
      }

      .warning .icon {
        color: oklch(0.65 0.18 85);
      }

      /* Severity: Error */
      .error {
        background-color: oklch(var(--r5-danger-l, 0.55) var(--r5-danger-c, 0.22) var(--r5-danger-h, 25) / 0.1);
        border-color: oklch(var(--r5-danger-l, 0.55) var(--r5-danger-c, 0.22) var(--r5-danger-h, 25) / 0.3);
        color: var(--r5-text);
      }

      .error .icon {
        color: var(--r5-danger, oklch(0.55 0.22 25));
      }

      /* Icon */
      .icon {
        flex-shrink: 0;
        width: 1.25rem;
        height: 1.25rem;
        margin-top: 0.0625rem;
      }

      .icon svg {
        width: 100%;
        height: 100%;
      }

      /* Content */
      .content {
        flex: 1;
        min-width: 0;
      }

      .title {
        font-size: var(--r5-text-sm);
        font-weight: var(--r5-font-semibold);
        color: var(--r5-text);
        margin: 0;
        line-height: var(--r5-leading-tight);
      }

      .description {
        font-size: var(--r5-text-sm);
        color: var(--r5-text-muted);
        margin: var(--r5-space-1) 0 0 0;
        line-height: var(--r5-leading-relaxed);
      }

      .description:empty {
        display: none;
      }

      /* Action */
      .action {
        display: flex;
        align-items: center;
        gap: var(--r5-space-2);
        margin-top: var(--r5-space-3);
      }

      .action:empty {
        display: none;
      }

      /* Close button */
      .close {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1.5rem;
        height: 1.5rem;
        padding: 0;
        border: none;
        background: transparent;
        color: var(--r5-text-muted);
        cursor: pointer;
        border-radius: var(--r5-radius-sm);
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
        margin: -0.125rem -0.125rem 0 0;
      }

      .close:hover {
        background-color: var(--r5-bg-muted);
        color: var(--r5-text);
      }

      .close:focus-visible {
        outline: var(--r5-focus-ring-width) solid var(--r5-focus-ring-color);
        outline-offset: var(--r5-focus-ring-offset);
      }

      .close svg {
        width: 1rem;
        height: 1rem;
      }

      /* Variants */
      .filled.info {
        background-color: var(--r5-info, oklch(0.55 0.18 250));
        border-color: var(--r5-info, oklch(0.55 0.18 250));
        color: white;
      }

      .filled.info .icon,
      .filled.info .title,
      .filled.info .description,
      .filled.info .close {
        color: white;
      }

      .filled.success {
        background-color: var(--r5-success, oklch(0.55 0.18 145));
        border-color: var(--r5-success, oklch(0.55 0.18 145));
        color: white;
      }

      .filled.success .icon,
      .filled.success .title,
      .filled.success .description,
      .filled.success .close {
        color: white;
      }

      .filled.warning {
        background-color: oklch(0.75 0.18 85);
        border-color: oklch(0.75 0.18 85);
        color: oklch(0.25 0.05 85);
      }

      .filled.warning .icon,
      .filled.warning .title,
      .filled.warning .description,
      .filled.warning .close {
        color: oklch(0.25 0.05 85);
      }

      .filled.error {
        background-color: var(--r5-danger, oklch(0.55 0.22 25));
        border-color: var(--r5-danger, oklch(0.55 0.22 25));
        color: white;
      }

      .filled.error .icon,
      .filled.error .title,
      .filled.error .description,
      .filled.error .close {
        color: white;
      }

      @media (prefers-reduced-motion: reduce) {
        .close {
          transition: none;
        }
      }
    `
];
t([
  l({ type: String, reflect: !0 })
], r.prototype, "severity", 2);
t([
  l({ type: String })
], r.prototype, "alertTitle", 2);
t([
  l({ type: String })
], r.prototype, "description", 2);
t([
  l({ type: Boolean, reflect: !0 })
], r.prototype, "closable", 2);
t([
  l({ type: String, reflect: !0 })
], r.prototype, "variant", 2);
t([
  f()
], r.prototype, "visible", 2);
r = t([
  u("ark-alert")
], r);
export {
  r as A
};
//# sourceMappingURL=ark-alert-BhH2bLtZ.js.map
